<template>
    <div class="danmu_page">
        <LoopScroll v-if="list.length > 0" :dataSource="list" itemKey="create_time" direction="up" :waitTime="1500"
            :speed="0.8" :loadCount="100" :pausedOnHover="false" @click="showDanmuListModal">
            <template #default="{ item }">
                <!-- <span>{{ item.id }}.{{ item.value }}</span> -->
                <div class="danmu-item-box">
                    <TxContainer src="zhongjiangdb" class="danmu-item">
                        <p>{{ item.variables.reward_name }}（{{ item.variables.urs }}）</p>
                    </TxContainer>
                </div>
            </template>
        </LoopScroll>
    </div>
</template>

<script lang="ts" setup>
import { ref, inject } from "vue";
import { LoopScroll } from "@joyday/vue-loop-scroll";
import { query_danmu } from '@utils/api';
import eventEmitter from '@utils/event';
const GlobalReporter = inject('GlobalReporter');

const list = ref([])

function queryDanmu() {
    query_danmu({
        activity_id: 'txwx',
        template_ids: [5],
        query_type: 3,
    }).then(res => {
        if (res.code !== 1) {
            return
        }
        list.value = res.data
        console.log('list', list.value);
    })
}
queryDanmu()

function showDanmuListModal() {
    return
    GlobalReporter.add({ btn_name: '中奖总览' });
    eventEmitter.emit('showDanmuListModal');
}
</script>

<style lang="scss" scoped>
.danmu_page {
    position: absolute;
    left: 10px;
    top: 0;
    transform: translate(0, 0px);
    font-size: 24px;
    height: 74px;
    // border: 1px solid #000;
    overflow: hidden;

    .danmu-item-box {
        padding-bottom: 10px;
        font-size: 17px;
        color: #fff;
    }

    .danmu-item {
        box-sizing: border-box;
        padding-left: 10px;

        p {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis; //文本溢出显示省略号
            white-space: nowrap; //文本不会换行
        }
    }
}
</style>